import axios from "@/api/axiosInstance";
import {
  ListSelectableCompaniesRequest,
  ListSelectableCompaniesResponse,
  SelectableCompaniesResult,
} from "./types";

/**
 * Every company, for the "New Diagnostic" picker — diagnosed or not. Bounded
 * and searchable: unbounded it returns the whole tenant table into a select.
 */
export const listSelectableCompanies = async (
  params: ListSelectableCompaniesRequest,
  signal?: AbortSignal,
): Promise<SelectableCompaniesResult> => {
  const response = await axios.get<ListSelectableCompaniesResponse>(
    "/api/private/diagnostics/companies/selectable",
    { params, signal },
  );
  return {
    companies: response.data.data.companies,
    // Falling back to the row count rather than to 0: the count the picker
    // reports must not contradict the options it just listed.
    totalCount:
      response.data.meta?.totalCount ?? response.data.data.companies.length,
    hasMore: response.data.meta?.hasMore ?? false,
  };
};
